import { render, staticRenderFns } from "./CrmSalonChamps.vue?vue&type=template&id=62ccc040&"
import script from "./CrmSalonChamps.vue?vue&type=script&lang=js&"
export * from "./CrmSalonChamps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports